import { render, staticRenderFns } from "./Estero.vue?vue&type=template&id=7ed84d84&scoped=true&"
import script from "./Estero.vue?vue&type=script&lang=js&"
export * from "./Estero.vue?vue&type=script&lang=js&"
import style0 from "./Estero.vue?vue&type=style&index=0&id=7ed84d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed84d84",
  null
  
)

export default component.exports